/**
 * Shared MapLibre GL loader + Ordnance Survey base style, used by the OS
 * building picker (create BP) and the planning constraints map.
 *
 * MapLibre is loaded from a CDN on demand so the ~250 KB library is not in the
 * main bundle for users who never open a map.
 */
const MAPLIBRE_VERSION = '5.6.1'
const MAPLIBRE_SCRIPT_ID = 'maplibre-gl-js'
const MAPLIBRE_STYLE_ID = 'maplibre-gl-css'
const MAPLIBRE_SCRIPT_URL = `https://unpkg.com/maplibre-gl@${MAPLIBRE_VERSION}/dist/maplibre-gl.js`
const MAPLIBRE_STYLE_URL = `https://unpkg.com/maplibre-gl@${MAPLIBRE_VERSION}/dist/maplibre-gl.css`

export const osVectorApiKey = process.env.REACT_APP_OS_VECTOR_TILE_API_KEY || ''
export const osMapsApiKey =
  process.env.REACT_APP_OS_MAPS_API_KEY ||
  process.env.REACT_APP_OS_PROJECT_API_KEY ||
  ''

export const osVectorStyleUrl = osVectorApiKey
  ? `https://api.os.uk/maps/vector/v1/vts/resources/styles?srs=3857&key=${encodeURIComponent(osVectorApiKey)}`
  : ''

export const osRasterStyle = osMapsApiKey
  ? {
      version: 8,
      sources: {
        'os-maps-raster': {
          type: 'raster',
          tiles: [
            `https://api.os.uk/maps/raster/v1/zxy/Road_3857/{z}/{x}/{y}.png?key=${encodeURIComponent(osMapsApiKey)}`
          ],
          tileSize: 256,
          minzoom: 5,
          maxzoom: 20,
          attribution:
            'Contains OS data &copy; Crown copyright and database rights'
        }
      },
      layers: [
        {
          id: 'os-maps-raster',
          type: 'raster',
          source: 'os-maps-raster'
        }
      ]
    }
  : null

export const osMapStyle = osVectorStyleUrl || osRasterStyle
export const hasInteractiveVectorMap = Boolean(osVectorStyleUrl)

export const waitForMapLibre = () =>
  new Promise((resolve, reject) => {
    if (window.maplibregl) {
      resolve(window.maplibregl)
      return
    }

    if (!document.getElementById(MAPLIBRE_STYLE_ID)) {
      const link = document.createElement('link')
      link.id = MAPLIBRE_STYLE_ID
      link.rel = 'stylesheet'
      link.href = MAPLIBRE_STYLE_URL
      document.head.appendChild(link)
    }

    const existingScript = document.getElementById(MAPLIBRE_SCRIPT_ID)

    if (existingScript) {
      existingScript.addEventListener(
        'load',
        () => resolve(window.maplibregl),
        {
          once: true
        }
      )
      existingScript.addEventListener('error', reject, { once: true })
      return
    }

    const script = document.createElement('script')
    script.id = MAPLIBRE_SCRIPT_ID
    script.src = MAPLIBRE_SCRIPT_URL
    script.async = true
    script.onload = () => resolve(window.maplibregl)
    script.onerror = reject
    document.body.appendChild(script)
  })
